var _circle, _circle2, _circle3, _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTakePhotoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 225,
    viewBox: "0 0 111 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.268,
    cy: 179.652,
    r: 12.1492,
    fill: "#414554"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2679,
    cy: 179.653,
    r: 11.9087,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2682,
    cy: 179.652,
    r: 13.2474,
    stroke: "#404041",
    strokeWidth: 1.71516,
    strokeDasharray: "1.72 1.72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.428791,
    y: 0.428791,
    width: 109.771,
    height: 208.393,
    rx: 21.0108,
    stroke: "#404041",
    strokeWidth: 0.857582
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1645_784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_1645_784",
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 182,
    width: 26,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 47,
    y: 182,
    width: 26,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0252 183C54.7107 183 53.645 184.066 53.645 185.38V197.455L53.6312 197.414C53.2033 196.172 51.8488 195.511 50.6059 195.939C49.363 196.367 48.7024 197.721 49.1303 198.964L52.9187 209.966C52.9453 210.044 52.9754 210.119 53.0089 210.191C53.2171 214.822 57.0372 218.512 61.7191 218.512C66.8355 218.512 70.9831 214.364 70.9831 209.248V207.516C71.1415 207.219 71.2313 206.88 71.2313 206.52V199.116C71.2313 197.947 70.2841 197 69.1157 197C67.9472 197 67 197.947 67 199.116V200.325C66.956 200.31 66.9118 200.295 66.8673 200.281V197.281C66.8673 196.112 65.9201 195.165 64.7517 195.165C63.5832 195.165 62.636 196.112 62.636 197.281V200H62.635V195.693C62.635 194.525 61.6878 193.577 60.5194 193.577C59.3784 193.577 58.4484 194.481 58.4053 195.611V185.38C58.4053 184.066 57.3397 183 56.0252 183Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0252 183C54.7107 183 53.645 184.066 53.645 185.38V197.455L53.6312 197.414C53.2033 196.172 51.8488 195.511 50.6059 195.939C49.363 196.367 48.7024 197.721 49.1303 198.964L52.9187 209.966C52.9453 210.044 52.9754 210.119 53.0089 210.191C53.2171 214.822 57.0372 218.512 61.7191 218.512C66.8355 218.512 70.9831 214.364 70.9831 209.248V207.516C71.1415 207.219 71.2313 206.88 71.2313 206.52V199.116C71.2313 197.947 70.2841 197 69.1157 197C67.9472 197 67 197.947 67 199.116V200.325C66.956 200.31 66.9118 200.295 66.8673 200.281V197.281C66.8673 196.112 65.9201 195.165 64.7517 195.165C63.5832 195.165 62.636 196.112 62.636 197.281V200H62.635V195.693C62.635 194.525 61.6878 193.577 60.5194 193.577C59.3784 193.577 58.4484 194.481 58.4053 195.611V185.38C58.4053 184.066 57.3397 183 56.0252 183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.645 197.455L52.6995 197.78L54.645 197.455H53.645ZM53.6312 197.414L52.6857 197.74L52.6857 197.74L53.6312 197.414ZM50.6059 195.939L50.2803 194.993H50.2803L50.6059 195.939ZM49.1303 198.964L48.1848 199.29L48.1848 199.29L49.1303 198.964ZM52.9187 209.966L51.9732 210.292L52.9187 209.966ZM53.0089 210.191L54.0079 210.146L53.9991 209.95L53.917 209.772L53.0089 210.191ZM70.9831 207.516L70.101 207.045L69.9831 207.265V207.516H70.9831ZM67 200.325L66.6725 201.27L68 201.73V200.325H67ZM66.8673 200.281H65.8673V201.011L66.5624 201.233L66.8673 200.281ZM62.636 200V201H63.636V200H62.636ZM62.635 200H61.635V201H62.635V200ZM58.4053 195.611H57.4053L59.4046 195.649L58.4053 195.611ZM54.645 185.38C54.645 184.618 55.2629 184 56.0252 184V182C54.1584 182 52.645 183.513 52.645 185.38H54.645ZM54.645 197.455V185.38H52.645V197.455H54.645ZM52.6857 197.74L52.6995 197.78L54.5906 197.129L54.5767 197.089L52.6857 197.74ZM50.9314 196.884C51.6521 196.636 52.4375 197.019 52.6857 197.74L54.5767 197.089C53.969 195.324 52.0454 194.386 50.2803 194.993L50.9314 196.884ZM50.0758 198.639C49.8277 197.918 50.2108 197.133 50.9314 196.884L50.2803 194.993C48.5152 195.601 47.577 197.525 48.1848 199.29L50.0758 198.639ZM53.8642 209.641L50.0758 198.639L48.1848 199.29L51.9732 210.292L53.8642 209.641ZM53.917 209.772C53.8975 209.73 53.8799 209.686 53.8642 209.641L51.9732 210.292C52.0107 210.401 52.0534 210.507 52.1009 210.61L53.917 209.772ZM61.7191 217.512C57.5744 217.512 54.1922 214.245 54.0079 210.146L52.0099 210.236C52.242 215.399 56.4999 219.512 61.7191 219.512V217.512ZM69.9831 209.248C69.9831 213.812 66.2832 217.512 61.7191 217.512V219.512C67.3878 219.512 71.9831 214.917 71.9831 209.248H69.9831ZM69.9831 207.516V209.248H71.9831V207.516H69.9831ZM70.2313 206.52C70.2313 206.712 70.1839 206.889 70.101 207.045L71.8652 207.987C72.0991 207.549 72.2313 207.049 72.2313 206.52H70.2313ZM70.2313 199.116V206.52H72.2313V199.116H70.2313ZM69.1157 198C69.7318 198 70.2313 198.5 70.2313 199.116H72.2313C72.2313 197.395 70.8364 196 69.1157 196V198ZM68 199.116C68 198.5 68.4995 198 69.1157 198V196C67.3949 196 66 197.395 66 199.116H68ZM68 200.325V199.116H66V200.325H68ZM66.5624 201.233C66.5993 201.245 66.636 201.257 66.6725 201.27L67.3275 199.38C67.276 199.363 67.2243 199.345 67.1722 199.329L66.5624 201.233ZM65.8673 197.281V200.281H67.8673V197.281H65.8673ZM64.7517 196.165C65.3678 196.165 65.8673 196.664 65.8673 197.281H67.8673C67.8673 195.56 66.4724 194.165 64.7517 194.165V196.165ZM63.636 197.281C63.636 196.664 64.1355 196.165 64.7517 196.165V194.165C63.0309 194.165 61.636 195.56 61.636 197.281H63.636ZM63.636 200V197.281H61.636V200H63.636ZM62.635 201H62.636V199H62.635V201ZM61.635 195.693V200H63.635V195.693H61.635ZM60.5194 194.577C61.1355 194.577 61.635 195.077 61.635 195.693H63.635C63.635 193.972 62.2401 192.577 60.5194 192.577V194.577ZM59.4046 195.649C59.4273 195.054 59.9179 194.577 60.5194 194.577V192.577C58.8389 192.577 57.4696 193.907 57.406 195.573L59.4046 195.649ZM57.4053 185.38V195.611H59.4053V185.38H57.4053ZM56.0252 184C56.7874 184 57.4053 184.618 57.4053 185.38H59.4053C59.4053 183.513 57.8919 182 56.0252 182V184Z",
    fill: "black",
    mask: "url(#path-5-outside-1_1645_784)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1645_784",
    x: 43.9998,
    y: 179,
    width: 32.2316,
    height: 45.5122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1645_784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1645_784",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhotoSvg);
export default __webpack_public_path__ + "static/media/Take PhotoSVG.7990a11e71de9d551d0d2610b641e8b5.svg";
export { ForwardRef as ReactComponent };